import React from 'react';
import ArrowIcon from '../ui/ArrowIcon';
import Reveal from '../ui/Reveal';
import './Footer.css';

const EMAIL = 'nevardogan@hotmail.com';

const LINKS = [
  { label: 'GitHub', href: 'https://github.com/nevaerdogan' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/nevaerdogan/' },
  { label: 'Medium', href: 'https://medium.com/@nevardogan' },
];

const Footer = () => (
  <footer className="foot">
    <div className="container">
      <Reveal className="foot-top">
        <span className="eyebrow">contact</span>
        <h2 className="t-display foot-title">Let's talk.</h2>
        <a className="foot-mail t-display" href={`mailto:${EMAIL}`}>
          {EMAIL} <ArrowIcon />
        </a>
      </Reveal>

      <div className="foot-bottom">
        <ul className="foot-links">
          {LINKS.map((l) => (
            <li key={l.label}>
              <a className="link-arrow" href={l.href} target="_blank" rel="noopener noreferrer">
                {l.label} <ArrowIcon />
              </a>
            </li>
          ))}
        </ul>
        <p className="mono foot-meta">© {new Date().getFullYear()} Neva Erdoğan</p>
      </div>
    </div>
  </footer>
);

export default Footer;
